import React, { useState } from 'react';

import Button from '../ui/Button';
import { CheckboxField } from '../ui/FormField';

// Group an applicant's files by category (default "Files").
const groupByCategory = (files) => {
    const categories = {};
    files.forEach((file) => {
        const category = file.category != undefined ? file.category : 'Files';
        if (categories[category] == undefined) {
            categories[category] = [];
        }
        categories[category].push(file);
    });
    return categories;
};

// One applicant's category-grouped checkbox grid.
const ApplicantChecklist = ({ applicantKey, applicant, onToggle }) => {
    const categories = groupByCategory(applicant.files);
    return (
        <div>
            {Object.keys(categories).map((categoryKey) => (
                <div key={categoryKey} className="mb-4 last:mb-0">
                    <p className="text-xs font-bold uppercase tracking-wide text-[#6B7280] mb-2">{categoryKey}</p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-2">
                        {categories[categoryKey].map((file) => (
                            <CheckboxField
                                key={`${applicantKey}_${file.index}`}
                                label={file.label}
                                name={`filebox_${applicantKey}_${file.index}`}
                                checked={file.requested == true}
                                onChange={() => onToggle(applicantKey, file.index)}
                            />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

// Shared checklist for requesting/editing document collections. With multiple
// applicants it shows one applicant at a time behind tabs, so the list stays
// short instead of stacking every applicant vertically (which forced the
// modal to scroll internally).
const DocRequestChecklist = ({ applicants, onToggle, onSelectAll }) => {
    const keys = Object.keys(applicants);
    const [activeKey, setActiveKey] = useState(keys[0]);

    if (keys.length === 0) return null;

    // Keep the active tab valid as the applicant list rebuilds.
    const currentKey = keys.includes(activeKey) ? activeKey : keys[0];

    return (
        <div>
            <div className="flex items-center justify-between gap-3 mb-4">
                {keys.length > 1 ? (
                    <div className="flex flex-wrap gap-1 rounded-xl bg-[#F5F6FA] p-1">
                        {keys.map((key) => (
                            <button
                                key={key}
                                type="button"
                                onClick={() => setActiveKey(key)}
                                className={`rounded-lg px-3 py-1.5 text-sm font-semibold transition-colors ${
                                    key === currentKey
                                        ? 'bg-white text-[#1F2937] shadow-sm'
                                        : 'text-[#6B7280] hover:text-[#1F2937]'
                                }`}
                            >
                                {applicants[key].name}
                            </button>
                        ))}
                    </div>
                ) : (
                    <h4 className="text-base font-bold text-[#1F2937]">{applicants[currentKey].name}</h4>
                )}
                <Button
                    variant="secondary"
                    className="!px-3 !py-1.5 !text-xs flex-shrink-0"
                    onClick={() => onSelectAll(currentKey)}
                >
                    Select All
                </Button>
            </div>

            <ApplicantChecklist
                applicantKey={currentKey}
                applicant={applicants[currentKey]}
                onToggle={onToggle}
            />
        </div>
    );
};

export default DocRequestChecklist;
